import { loadCatalog } from "./catalog";

export const isAntiGaspiActive = (product) => {
  if (!product || !product.antiGaspiDiscount || Number(product.antiGaspiDiscount) <= 0) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (product.antiGaspiStartsAt) {
    const start = new Date(`${product.antiGaspiStartsAt}T00:00:00`);
    if (start > today) return false;
  }
  if (product.antiGaspiExpiresAt) {
    const expiry = new Date(`${product.antiGaspiExpiresAt}T00:00:00`);
    if (expiry < today) return false;
  }
  return true;
};

export const getAntiGaspiPrice = (product) => {
  if (!isAntiGaspiActive(product)) return null;
  const price = Number(product.price || 0);
  const discount = Number(product.antiGaspiDiscount || 0);
  return Math.round(price * (1 - discount / 100) * 100) / 100;
};

export const getEffectiveUnitPrice = (product) => {
  const reduced = getAntiGaspiPrice(product);
  return reduced !== null ? reduced : Number(product.price || 0);
};

export const getAntiGaspiLinePricing = (product, quantity) => {
  const unitPrice = Number(product?.price || 0);
  const qty = Number(quantity || 0);
  const reducedPrice = getAntiGaspiPrice(product);
  const isWeighted = !!(product?.price_per_kg || product?.isWeighted);
  const cap = Number(product?.antiGaspiMaxQty || 0);

  if (reducedPrice === null || qty <= 0) {
    return {
      reducedPrice: null,
      unitPrice,
      discountedQty: 0,
      fullQty: qty,
      lineTotal: unitPrice * qty,
      blendedUnitPrice: unitPrice,
    };
  }

  const discountedQty = isWeighted || cap <= 0 ? qty : Math.min(qty, cap);
  const fullQty = qty - discountedQty;
  const lineTotal = discountedQty * reducedPrice + fullQty * unitPrice;
  return {
    reducedPrice,
    unitPrice,
    discountedQty,
    fullQty,
    lineTotal,
    blendedUnitPrice: Math.round((lineTotal / qty) * 10000) / 10000,
  };
};

export const formatEur = (value) => `${Number(value || 0).toFixed(2).replace(".", ",")} EUR`;

export const loadAntiGaspiProducts = async () => {
  const catalog = await loadCatalog();
  return catalog
    .filter((p) => isAntiGaspiActive(p))
    .map((p) => ({
      ...p,
      originalPriceLabel: formatEur(p.price),
      antiGaspiPrice: getAntiGaspiPrice(p),
      antiGaspiPriceLabel: formatEur(getAntiGaspiPrice(p)),
      image: p.imageUrl || "https://almoune.fr/img/p/0.jpg",
    }))
    .sort((a, b) => (b.antiGaspiDiscount || 0) - (a.antiGaspiDiscount || 0));
};